import { Box, Typography } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import React, { useEffect, useState } from 'react';
import { ProgressButton } from 'src/common';
import { Props } from '../container';
import {
  DownloadTemplatePayload,
  ReportTemplate,
  TemplateType,
} from '../store/types';
import { ReportTemplateColumns } from './ReportTemplateColumns';
import { ReportTemplateModal } from './ReportTemplateModal';

export const ReportTemplateComponent = ({
  fetchReportTemplates,
  templates,
  saveReportTemplateFile,
  saveReportTemplateFileProgress,
  fetchReportTemplatesProgress,
  downloadReportTemplateFile,
}: Props): JSX.Element => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [row, setRow] = useState<ReportTemplate | null>(null);
  const [templateType, setTemplateType] = useState<TemplateType>('Word');

  const handleImport = (name: string, file?: File) => {
    saveReportTemplateFile({
      id: row?.id ?? '',
      name: name,
      file: file,
      templateFormat: templateType,
    });
    setModalOpen(false);
  };

  const handleOpenEditModal = (row: ReportTemplate, type: TemplateType) => {
    setRow(row);
    setTemplateType(type);
    setModalOpen(true);
  };

  const handleDownloadTemplate = (payload: DownloadTemplatePayload) => {
    downloadReportTemplateFile(payload);
  };

  const handleOpenModal = () => {
    setRow(null);
    setTemplateType('Word');
    setModalOpen(true);
  };

  useEffect(() => {
    fetchReportTemplates();
  }, []);

  return (
    <Box style={{ paddingTop: '20px' }}>
      <Box display="flex" flexDirection="column" gap={2}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h2">Templates</Typography>
          <ProgressButton
            color="primary"
            style={{ borderRadius: 24, height: 48 }}
            disableElevation
            disabled={saveReportTemplateFileProgress.isLoading}
            onClick={handleOpenModal}
            variant="contained"
          >
            ADD TEMPLATE
          </ProgressButton>
        </Box>

        <DataGridPro
          loading={fetchReportTemplatesProgress.isLoading || saveReportTemplateFileProgress.isLoading}
          autoHeight
          pagination
          disableSelectionOnClick
          columns={ReportTemplateColumns({
            setEditRow: handleOpenEditModal,
            downloadTemplate: handleDownloadTemplate,
          })}
          rows={templates}
        />
      </Box>

      <ReportTemplateModal
        row={row}
        isOpen={modalOpen}
        handleClose={() => setModalOpen(false)}
        handleImport={handleImport}
        templateType={templateType}
        setTemplateType={setTemplateType}
      />
    </Box>
  );
};
